import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/pkg-onboarding/user-webapp/src/app/layout_client.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/pkg-onboarding/user-webapp/src/app/providers/design_tokens_provider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/pkg-onboarding/user-webapp/src/app/providers/tenant_provider.tsx");
